import { IGetMessengerConversationsRequest } from '../../indigofair/data/IGetMessengerConversationsRequest';
import { IImage } from '../../indigofair/data/IImage';
import { IMessengerConversation } from '../../indigofair/data/IMessengerConversation';

export namespace IGetMessengerConversationsResponse {
  export namespace ISimpleRetailer {
    /**
     * Return an instance of ISimpleRetailer with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<ISimpleRetailer>
    ): ISimpleRetailer =>
      ({
        ...(partial ?? {}),
      }) as ISimpleRetailer;
  }

  /**
   * A simplified view of a Retailer containing only information required for Messenger.
   */
  export interface ISimpleRetailer {
    name: string | undefined;
    token: string | undefined;
  }

  export namespace ISimpleBrand {
    /**
     * Return an instance of ISimpleBrand with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<ISimpleBrand>): ISimpleBrand =>
      ({
        ...(partial ?? {}),
      }) as ISimpleBrand;
  }

  /**
   * A simplified view of a Retailer containing only information required for Messenger.
   */
  export interface ISimpleBrand {
    token: string | undefined;
    profile_image: IImage | undefined;
    vacation_start_date: number | undefined;
    vacation_end_date: number | undefined;
    owner_user_token: string | undefined;
    hide_chat: boolean | undefined;
    name: string | undefined;
    active: boolean | undefined;
    /**
     * True if the brand qualifies as a Top Shop for the current cycle
     */
    is_top_shop: boolean | undefined;
  }

  /**
   * Return an instance of IGetMessengerConversationsResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetMessengerConversationsResponse>
  ): IGetMessengerConversationsResponse =>
    ({
      conversations: [],
      simple_brands: {},
      simple_retailers: {},
      ...(partial ?? {}),
    }) as IGetMessengerConversationsResponse;
}

export interface IGetMessengerConversationsResponse {
  /**
   * The list of conversations.
   */
  conversations: Array<IMessengerConversation>;
  /**
   * The request object to be used to load more conversations, if any.
   */
  next_request: IGetMessengerConversationsRequest | undefined;
  /**
   * A map of brand token to SimpleBrand, for all brands owned by users in conversations.
   */
  simple_brands: Partial<
    Record<string, IGetMessengerConversationsResponse.ISimpleBrand>
  >;
  /**
   * A map of retailer token to SimpleRetailer, for all retailers owned by users in conversations.
   */
  simple_retailers: Partial<
    Record<string, IGetMessengerConversationsResponse.ISimpleRetailer>
  >;
  total_conversations: number | undefined;
  total_unread_conversations: number | undefined;
  total_starred_by_brand_conversations: number | undefined;
}
